import { render, staticRenderFns } from "./Parametric.vue?vue&type=template&id=055b6f0c"
import script from "./Parametric.vue?vue&type=script&lang=js"
export * from "./Parametric.vue?vue&type=script&lang=js"
import style0 from "./Parametric.vue?vue&type=style&index=0&id=055b6f0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports